export const getBaseDomain = () => {
  const domainParts = window.location.hostname.split('.');
  return domainParts.length >= 2
    ? `.${domainParts[domainParts.length - 2]}.${
        domainParts[domainParts.length - 1]
      }`
    : window.location.hostname;
};
